'use client'

import { type FC } from 'react'

import { useStoryblokStory } from '../../../../context/StoryblokStoryContext'

import { StoryblokCategoryNavigationButton } from './mobile/StoryblokCategoryNavigationButton'
import { StoryblokCategoryNavigationProvider } from './mobile/StoryblokCategoryNavigationProvider'
import { StoryblokCategoryNavigationSlider } from './mobile/StoryblokCategoryNavigationSlider'

export const StoryblokCategoryNavigationMobile: FC = () => {
  const { enrichedData } = useStoryblokStory()

  if (!enrichedData?.hierarchy) {
    return null
  }

  return (
    <section className="container flex items-center tablet:hidden">
      <StoryblokCategoryNavigationProvider
        initialCategoryData={enrichedData.hierarchy}
      >
        <StoryblokCategoryNavigationButton />
        <StoryblokCategoryNavigationSlider />
      </StoryblokCategoryNavigationProvider>
    </section>
  )
}
